import { directDownloadBinary } from "./download";

function pad(n) {
  return String(n).padStart(2, "0");
}

export function V2_getMaxFrameFromAsset(asset)
{
    if ("viid" in asset)
        return V2_getMaxFrame(asset.vinum,asset.viden);
    else
        return V2_getMaxFrame(asset.asnum,asset.asden);

}
export function V2_getMaxFrame (num, den)
{
    if (!den) return 25;
    return Math.round(num/den);

}

export function V2_recfps (num, den)
{
    switch (num)
    {
        case 24:
            return 24;
        case 24000:
            if (den === 1001)
                return 23.98;
            return 24;
        case 25:
        case 25000:
            return 25;
        case 30:
            return 30;
        case 23976:
            return 23.98;
        case 29970:
            return 29.97;
            
        case 30000:
            if (den === 1001)
                return 29.97;
            return 30;
    }
    return 25;
}


export function V2_RoundedTimeCode(
    time,     
    num = 25,
    den = 1,
    dropframe = 0,
    timecodestart = "00:00:00:00"
)
{

    time  = Number(time.toFixed(3));
    const time0 = Math.trunc (time);
    //console.log("en entree", time0,  time);
    time = time - time0;
    
    var fd = Number(V2_GetOneFrameDuration(num,den).toFixed(3));
    //console.log("en sortie", time0, fd, time);
    time = Number((Math.round(time / fd) * fd).toFixed(3));

    //console.log("final", time0, fd, time);
    
    return time0 + time;

}


export function V2_GetOneFrameDuration(num,den)
{
    const fps = V2_recfps(num,den);
    return 1/fps;

}
export function V2_ConvertTimeCodeStringToSecond (
    timecode, // hh:mm:ss:ii ou hh:mm:ss:mmm
    num = 25,
    den = 1,
    dropframe = 0,
    timecodestart = "00:00:00:00" 
)
{
    const fps = V2_recfps(num,den);

    
    if (timecode.length === 11 )
    {
        const [HH, MM, SS, FF] = timecode.split(":").map(Number);

        
  
        // Frames total dans le timecode
        let totalFrames;

        // --- DROP FRAME ---
        if ((dropframe===1)  && (fps === 29.97 || fps === 30)) {
            const DFfps = 30; // calcul basé sur 30fps
            const dropFrames = Math.round(DFfps * 0.066666); // 2 frames par minute
            const framesPerHour = DFfps * 60 * 60;
            const framesPerMinute = DFfps * 60;
            const framesPer10Min = framesPerMinute * 10;

            let totalMinutes = HH * 60 + MM;

            // Nombre de frames droppées
            let droppedFrames =
            dropFrames * (totalMinutes - Math.floor(totalMinutes / 10));

            // Calcul: frames comptées (sans drop) - frames droppées
            totalFrames =
            (HH * 3600 + MM * 60 + SS) * DFfps + FF - droppedFrames;

        } else {
            // --- NON DROP FRAME ---
            totalFrames =
            (HH * 3600 + MM * 60 + SS) * Math.round(fps) + FF;
        }

        // Conversion en secondes (fps fractionnel ok)
        return totalFrames / fps;        

    }


    if (timecode.length === 12 )
    {
        const tc = timecode.replace(".",":");

        
        const [hh, mm, ss, mmm] = tc.split(":").map(Number);
        return hh * 3600 + mm * 60 + ss + mmm / 1000;        
    }
    return -1;
}

export function V2_ConvertSecondToTimeCodeStringMs (

    totalSeconds, // hh:mm:ss:ii ou hh:mm:ss:mmm
    num = 25,
    den = 1,
    dropframe = 0,
    timecodestart = "00:00:00:00",
    comma=false
)
{


    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);
    var milliseconds = totalSeconds % 1;
    milliseconds = V2_RoundedTimeCode(milliseconds, num, den) * 1000;

    const pad = (n, width = 2) => n.toString().padStart(width, "0");
    if (comma)
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)},${pad(milliseconds, 3)}`;
    else
        return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}.${pad(milliseconds, 3)}`;

}
export function V2_GetSecondTimeCodeStartMS(timecodestart,num,den,dropframe=1)
{
    const fps = V2_recfps(num,den);
    switch (fps)
    {
        case 24:
            return V2_ConvertTimeCodeStringToSecond(timecodestart,24,1,0,"00:00:00:00");
        case 23.98:
            return V2_ConvertTimeCodeStringToSecond(timecodestart,24,1,0,"00:00:00:00");
        case 25:
            return V2_ConvertTimeCodeStringToSecond(timecodestart,25,1,0,"00:00:00:00");
        case 30:
            return V2_ConvertTimeCodeStringToSecond(timecodestart,30,0,0,"00:00:00:00");
        case 29.97:
            return V2_ConvertTimeCodeStringToSecond(timecodestart,30,0,0,"00:00:00:00");

        
    }
    return 0;

}

export function V2_GetSecondTimeCodeStart(timecodestart,num,den,dropframe=1)
{
    const fps = V2_recfps(num,den);
    switch (fps)
    {
        case 24:
            return V2_ConvertTimeCodeStringToSecond(timecodestart,24,1,0,"00:00:00:00");
        case 23.98:
            return V2_ConvertTimeCodeStringToSecond(timecodestart,24000,1001,0,"00:00:00:00");
        case 25:
            return V2_ConvertTimeCodeStringToSecond(timecodestart,25,1,0,"00:00:00:00");
        case 30:
            return V2_ConvertTimeCodeStringToSecond(timecodestart,30,0,0,"00:00:00:00");
        case 29.97:
            return V2_ConvertTimeCodeStringToSecond(timecodestart,30000,1001,dropframe,"00:00:00:00");

        
    }
    return 0;

}


export function V2_ConvertSecondToTimeCodeString (

    seconds, // hh:mm:ss:ii ou hh:mm:ss:mmm
    num = 25,
    den = 1,
    dropframe = 0,
    timecodestart = "00:00:00:00"
)
{

    const fps = V2_recfps(num,den);
    
    seconds = V2_RoundedTimeCode(seconds,num,den,dropframe,timecodestart);

    
    const totalFrames = Math.round(seconds * fps);

    if ((dropframe != 0) &&  (fps === 29.97 || fps === 30)) 
    {
        // On arrondit à 30 pour le calcul DF
        const DFfps = 30;
        const dropFrames = Math.round(DFfps * 0.066666); // 2 frames par minute
        const framesPer10Minutes = DFfps * 60 * 10; // 18000 frames

        let d = totalFrames;

        const tenMinBlocks = Math.floor(d / framesPer10Minutes);
        let remaining = d % framesPer10Minutes;

        // Nombre de frames droppées par minute sauf chaque 10 minutes
        let dropped = dropFrames * (9 * tenMinBlocks);

        // Pour les minutes hors blocs de 10 min
        const mins = Math.floor(remaining / (DFfps * 60));
        dropped += dropFrames * Math.max(0, mins - 1);

        const countedFrames = d + dropped;

        let frames = countedFrames % DFfps;
        let totalSeconds = Math.floor(countedFrames / DFfps);

        let s = totalSeconds % 60;
        let totalMinutes = Math.floor(totalSeconds / 60);
        let m = totalMinutes % 60;
        let h = Math.floor(totalMinutes / 60);

        return `${pad(h)}:${pad(m)}:${pad(s)}:${pad(frames)}`;
    }

    // --- NON DROP FRAME ---
    const frames = totalFrames % Math.round(fps);

    

    //let totalSeconds = Math.floor(totalFrames / Math.round(fps));

    let totalSeconds = Math.floor(totalFrames / Math.round(fps));

    let s = totalSeconds % 60;
    let totalMinutes = Math.floor(totalSeconds / 60);
    let m = totalMinutes % 60;
    let h = Math.floor(totalMinutes / 60);

    return `${pad(h)}:${pad(m)}:${pad(s)}:${pad(frames)}`;
}


export function V2_ConvertSecondToTimeCodeString_for_test (

    seconds, // hh:mm:ss:ii ou hh:mm:ss:mmm
)
{



    const fps = 25;
    
   
    const totalFrames = Math.round(seconds * fps);
    // --- NON DROP FRAME ---
    const frames = totalFrames % Math.round(fps);

    let totalSeconds = Math.floor(totalFrames / Math.round(fps));

    let s = totalSeconds % 60;
    let totalMinutes = Math.floor(totalSeconds / 60);
    let m = totalMinutes % 60;
    let h = Math.floor(totalMinutes / 60);

    return `${pad(h)}:${pad(m)}:${pad(s)}:${pad(frames)}`;
}


export function V2_framesToSeconds(frameCount, num=25, den=1, dropFrame = false)
 {
  const fps = V2_recfps(num,den);
  // --- DROP FRAME 29.97 ---
  if (dropFrame && (fps === 29.97 || fps === 30)) {
    const DFfps = 30;                    // base de calcul SMPTE
    const dropFrames = 2;                // 2 frames par minute
    const framesPerHour = DFfps * 60 * 60; 
    const framesPer10Min = DFfps * 60 * 10;
    
    // Nombre de blocs de 10 minutes
    const tenMinBlocks = Math.floor(frameCount / framesPer10Min);
    let remaining = frameCount % framesPer10Min;

    // Frames droppés : 2 frames pour chaque minute sauf chaque 10min
    let dropped = dropFrames * (9 * tenMinBlocks);

    // Minutes dans le bloc restant
    const minutes = Math.floor(remaining / (DFfps * 60));
    dropped += dropFrames * Math.max(0, minutes - 1);

    // Frames réellement écoulés (sans compensation dropframe)
    const realFrames = frameCount - dropped;

    return realFrames / fps; // fps fractionnel ok
  }

  // --- NON DROP FRAME ---
  return frameCount / fps;
}

export function V2_secondsToFrames(seconds, num=25, den= 1, dropFrame = false) {
  // Frames théoriques (fractionnels si fps fractionnel)
  const fps = V2_recfps(num,den);
  let totalFrames = seconds * fps;

  // --- NON DROP FRAME ---
  if (!dropFrame || (fps !== 29.97 && fps !== 30)) {
    return Math.round(totalFrames);
  }

  // --- DROP FRAME (29.97 ou 30) ---
  const DFfps = 30;            // base SMPTE
  const dropFrames = 2;        // 2 frames/minute
  const framesPer10Min = DFfps * 60 * 10; // 18000
  const framesPerMinute = DFfps * 60;     // 1800

  // On convertit en frames nominales à 30fps
  let d = Math.round(seconds * DFfps);

  // Nombre de blocs de 10 minutes
  const tenMinBlocks = Math.floor(d / framesPer10Min);
  let remaining = d % framesPer10Min;

  // Frames à drop par bloc de 10 minutes
  let dropped = dropFrames * (9 * tenMinBlocks);

  // Minutes dans le bloc restant
  const minutes = Math.floor(remaining / framesPerMinute);

  // Drop dans le bloc sauf la première minute
  dropped += dropFrames * Math.max(0, minutes - 1);

  // Frames DF comptés → NDF totalFrames
  return d - dropped;
}


export function V2_FormatTimeCodeString(hrs,mins,secs,frames)
{
    return `${pad(hrs)}:${pad(mins)}:${pad(secs)}:${pad(frames)}`;
}

export function V2_timeToTimeCodeN19(seconds, num=25,den=1, dropframe=0,timecodestart="00:00:00:00")
{
    var tc = V2_ConvertSecondToTimeCodeString(seconds,num,den,dropframe,timecodestart);

    const h = parseInt(tc.substring(0,3));
    const m = parseInt(tc.substring(3,6));
    const s = parseInt(tc.substring(6,9));
    const i = parseInt(tc.substring(9,11));

    return String.fromCharCode(h)+String.fromCharCode(m)+String.fromCharCode(s)+String.fromCharCode(i);
}


export function V2_GetTimeCodeStartToSecondFromAsset(asset)
{
    if ("viid" in asset)
        return V2_ConvertTimeCodeStringToSecond(
            asset.vitimecode,
            asset.vinum,
            asset.viden,
            asset.vidropframe,
            asset.vitimecode)
    else
        return V2_ConvertTimeCodeStringToSecond(
            asset.astimecode,
            asset.asnum,
            asset.asden,
            asset.asdropframe,
            asset.astimecode)

}

export function V2_ConvertTimeCodeStringToSecondFromAsset(timecode,asset)
{
    if ("viid" in asset)
        return V2_ConvertTimeCodeStringToSecond(
            timecode,
            asset.vinum,
            asset.viden,
            asset.vidropframe,
            asset.vitimecode)
    else
        return V2_ConvertTimeCodeStringToSecond(
            timecode,
            asset.asnum,
            asset.asden,
            asset.asdropframe,
            asset.astimecode)
}


export function V2_ConvertSecondToTimeCodeStringFromAsset(second,asset, displaytcms,comma=false)
{


    
    if ("viid" in asset)
    {
        if (displaytcms)        
            return V2_ConvertSecondToTimeCodeStringMs(
                second,
                asset.vinum,
                asset.viden,
                asset.vidropframe,
                asset.vitimecode, comma)
        else
        {
            return  V2_ConvertSecondToTimeCodeString(
                second,
                asset.vinum,
                asset.viden,
                asset.vidropframe,
                asset.vitimecode)
        }

    }
    else
    {
        if (displaytcms)        
            return V2_ConvertSecondToTimeCodeStringMs(
                second,
                asset.asnum,
                asset.asden,
                asset.asdropframe,
                asset.astimecode, comma)
        else
            return V2_ConvertSecondToTimeCodeString(
                second,
                asset.asnum,
                asset.asden,
                asset.asdropframe,
                asset.astimecode)

    }
}


export function V2_GetOneFrameDurationFromAsset(asset)
{
    if ("viid" in asset)
    {
        return V2_GetOneFrameDuration(asset.vinum, asset.viden);
    }
    else
    {
        return V2_GetOneFrameDuration(asset.asnum, asset.asden);
    }

}



export function V2_getIntervalStringFromAsset (secondsBefore, seconds, asset, displayms)
{

    //$$

    var num = 25; var den = 1; var dropframe=0; var timecode="00:00:00:00"

    if ("viid" in asset)
    {
        num = asset.vinum;
        den = asset.viden;
        dropframe = asset.vidropframe;
        timecode = asset.vitimecode;
    }
    else
    {
        num = asset.asnum;
        den = asset.asden;
        dropframe = asset.asdropframe;
        timecode = asset.astimecode;

    }




    seconds  = V2_RoundedTimeCode(seconds,den,dropframe,timecode);
    secondsBefore  = V2_RoundedTimeCode(secondsBefore,den,dropframe,timecode);


    
    
    const sec = V2_RoundedTimeCode(seconds - secondsBefore,den,dropframe,timecode);
    

    if (displayms)
    {
        if (secondsBefore > seconds) return "**.***";
        
        
        if (sec <60)
        {
            // hh:mm:ss:mmm
            
            const ssec = V2_ConvertSecondToTimeCodeStringFromAsset(sec, asset,true);

            
            return ssec.substring(6);
        }
        else
            return "**.***"
    }
    else    
    {
        if (secondsBefore > seconds) return "**.**";
        
        if (sec <60)
        {
            // hh:mm:ss:mmm
            
            const ssec = V2_ConvertSecondToTimeCodeStringFromAsset(sec, asset,false);
            
            return ssec.substring(6);
        }
        else
            return "**.**"

    }

}

export function V2_checkTimeCode (timecodeString,  asset)
{
    if (timecodeString.length === 12)
    {
        const h = parseInt(timecodeString.substring(0,3));
        const m = parseInt(timecodeString.substring(3,6));
        const s = parseInt(timecodeString.substring(6,9));
        const ms = parseInt(timecodeString.substring(9,11));

        if ((h > 23 ) || (m > 59) || (s>59) || (ms >999)) return false;
        return true;
    }

    if (timecodeString.length !== 11) return false;
    const h = parseInt(timecodeString.substring(0,3));
    const m = parseInt(timecodeString.substring(3,6));
    const s = parseInt(timecodeString.substring(6,9));
    const i = parseInt(timecodeString.substring(9,11));

    var maxi = 24;
    if ((h > 23 ) || (m > 59) || (s>59) ) return false;

    var den = 1;
    var num = 25;
    if ("viid" in asset)    
    {
        den = asset.viden;
        num = asset.vinum;
    }
    else
    {
        den = asset.asden;
        num = asset.asnum;

    }


    switch (num)
    {
        case 25: 
            maxi = 24; break;
        case 24000: // den=1001 23,98 fps
        case 24:
            maxi = 23; break;
        case 30:
        case 30000: // den=1001 29,97 fps
            maxi = 29; break;
    }
    
    console.log(num,den,i,maxi);
    return (i <= maxi) ;



}

export function V2_TimecodeGetTimeCodeFormatString(num,den,dropframe=0)
{
    const fps = V2_recfps(num,den);

    var ret = fps.toString()+" fps";
    if (fps>25)
    {
        if (dropframe === 1)
            ret = ret + " DF";
        else
            ret = ret +" NDF"
    }
    return ret;
}

/*
{
    "type": "interval",
    "parameters": {
        "section1": {
            "enabled": true,
            "method": 2,
            "value": 5
        },
        "section2": {
            "enabled": false,
            "value": 5,
            "ignoreSceneChanges": false
        },
        "section3": {
            "in": {
                "enabled": false,
                "value": 4,
                "nearEnabled": false,
                "nearValue": 4
            },
            "out": {
                "enabled": false,
                "value": 4,
                "nearEnabled": false,
                "nearValue": 4
            }
        }
    },
    "range": {
        "subtitles": "range",
        "range": {
            "min": 1,
            "max": 14
        }
    }
}



*/

function FindCpBefore (tc,cplist) // cp inverse
{
  
    const cp = cplist.find (cp => cp.time <= tc && !cp.off);  
    if (cp == undefined)
        return 0;
    return cp.time;
}

//  *****************************************************************************************
// recherche changement plan apres le time code 
//  *****************************************************************************************

function FindCpAfter(tc,cplist)
{
    const cp = cplist.find (cp => cp.time >= tc && !cp.off);  
    if (cp == undefined)
        return 24 * 60 * 60; // tcmax
    return cp.time;
}

// ****************************************************************************
// correction des intervalles
// ****************************************************************************

export function V2_CorrectInterval(
    parameters,
    subtitlenumber,
    subltitles,
    cplist = null,
    num = 25,
    den = 1,
    dropframe = 0,
    timecode = "00:00:00:00"
)
{
    const cpvalide = Array.isArray(cplist);
    var cplistinverse = [];
    
    if (
        (cpvalide) &&

        (parameters.section2.enabled || parameters.section3.in.enabled || parameters.section3.out.enabled)
    )
        cplistinverse = cplist.slice().reverse(); // pour searchBofre


    // section 1 - correction intervalle entre sous titre
    if (parameters.section1.enabled)
    {
        if (subtitlenumber != 0)
        {
            var tcout = subltitles[subtitlenumber-1].out;
            var tcin = subltitles[subtitlenumber].in;

            tcout = V2_RoundedTimeCode(tcout,num,den,dropframe,timecode);
            tcin = V2_RoundedTimeCode(tcin,num,den,dropframe,timecode);

            const interms = V2_RoundedTimeCode( parameters.section1.value * V2_GetOneFrameDuration(num,den),num,den,dropframe,timecode);
            if ((tcin - tcout < interms) && (tcin - tcout >= 0))
            {
                // on corige les intervalles
                switch (parameters.section1.method)
                {
                    case 0:
                        tcin = tcout + interms;
                        break;
                    case 1:
                        tcout = tcin - interms;
                        if (tcout < 0) tcout = 0;
                        break;
                    case 2:
                        var x = (tcin - tcout - interms) / 2;
                        tcout +=x ;
                        tcout = V2_RoundedTimeCode(tcout,num,den,dropframe,timecode);
                        tcin = tcout + interms;
                        break;
                }
            }

            subltitles[subtitlenumber-1].out = tcout;
            subltitles[subtitlenumber].in = tcin;

        }
    }

    // section 2 - correction intervalle entre sous titre proche de l'intervalle
    // ignoreSceneChanges si on ne tient pas compte des cp
    if (parameters.section2.enabled)
    {
        if (subtitlenumber != 0)
        {
            var tcout = subltitles[subtitlenumber-1].out;
            var tcin = subltitles[subtitlenumber].in;

            tcout = V2_RoundedTimeCode(tcout,num,den,dropframe,timecode);
            tcin = V2_RoundedTimeCode(tcin,num,den,dropframe,timecode);

            const interms = V2_RoundedTimeCode( parameters.section1.value * V2_GetOneFrameDuration(num,den),num,den,dropframe,timecode);
            const interseuilms = V2_RoundedTimeCode( parameters.section2.value * V2_GetOneFrameDuration(num,den),num,den,dropframe,timecode);

            if ((tcin - tcout <= interseuilms) && (tcin - tcout >= 0) && (parameters.section2.ignoreSceneChanges || !cpvalide))
            {
                // on corige les intervalles
                switch (parameters.section1.method)
                {
                    case 0:
                        tcin = tcout + interms;
                        break;
                    case 1:
                        tcout = tcin - interms;
                        if (tcout < 0) tcout = 0;
                        break;
                    case 2:
                        var x = (tcin - tcout - interms) / 2;
                        tcout +=x ;
                        tcout = V2_RoundedTimeCode(tcout,num,den,dropframe,timecode);
                        tcin = tcout + interms;
                        break;
                }
            }
            else
            {
                if ((tcin - tcout <= interseuilms) && (tcin - tcout >= 0) )
                {
                    // cas avec changements de plans

                    var cpafter = FindCpAfter (tcout, cplist);
                    cpafter = V2_RoundedTimeCode(cpafter,num,den,dropframe,timecode);
                    if (tcin < cpafter)
                    {
                        switch (parameters.section1.method)
                        {
                            case 0:
                                tcin = tcout + interms;
                                break;
                            case 1:
                                tcout = tcin - interms;
                                if (tcout < 0) tcout = 0;
                                break;
                            case 2:
                                var x = (tcin - tcout - interms) / 2;
                                tcout +=x ;
                                tcout = V2_RoundedTimeCode(tcout,num,den,dropframe,timecode);
                                tcin = tcout + interms;
                                break;
                        }

                    }




                }

            }

            subltitles[subtitlenumber-1].out = tcout;
            subltitles[subtitlenumber].in = tcin;

        }
    }



    // on regarde le time code In
    
    if ((parameters.section3.in.enabled) && (cpvalide))
    {

        var tcout = subltitles[subtitlenumber].out;
        var tcin = subltitles[subtitlenumber].in;
        tcout = V2_RoundedTimeCode(tcout,num,den,dropframe,timecode);
        tcin = V2_RoundedTimeCode(tcin,num,den,dropframe,timecode);

        console.log("liste inverse ", cplist, cplistinverse)
        var cpbefore = FindCpBefore (tcin, cplistinverse);
        cpbefore = V2_RoundedTimeCode(cpbefore,num,den,dropframe,timecode);

        
        if (cpbefore > 0)
        {
            const value = V2_RoundedTimeCode( parameters.section3.in.value * V2_GetOneFrameDuration(num,den),num,den,dropframe,timecode);            
            if (tcin < (cpbefore + value))
                tcin = cpbefore + value;
            else
            {
                if (parameters.section3.in.nearEnabled)
                {
                    const nearValue = V2_RoundedTimeCode( parameters.section3.in.nearValue * V2_GetOneFrameDuration(num,den),num,den,dropframe,timecode);            
                    if (tcin <= (cpbefore + nearValue))
                        tcin = cpbefore + value;
                }
            }


        }


        subltitles[subtitlenumber].in = tcin;
    }

    // on regarde le time code Out
    
    if ((parameters.section3.out.enabled) && (cpvalide))
    {

        var tcout = subltitles[subtitlenumber].out;
        var tcin = subltitles[subtitlenumber].in;
        tcout = V2_RoundedTimeCode(tcout,num,den,dropframe,timecode);
        tcin = V2_RoundedTimeCode(tcin,num,den,dropframe,timecode);

        
        var cpafter = FindCpAfter (tcout, cplist);
        cpafter = V2_RoundedTimeCode(cpafter,num,den,dropframe,timecode);

        
        const value = V2_RoundedTimeCode( parameters.section3.out.value * V2_GetOneFrameDuration(num,den),num,den,dropframe,timecode);            
        if (tcout > (cpafter - value))
            tcout = cpafter - value;
        else
        {
            if (parameters.section3.out.nearEnabled)
            {
                const nearValue = V2_RoundedTimeCode( parameters.section3.out.nearValue * V2_GetOneFrameDuration(num,den),num,den,dropframe,timecode);            
                if (tcout >= (cpafter - nearValue))
                    tcout = cpafter - value;
            }
        }




        subltitles[subtitlenumber].out = tcout;
    }

}
